import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackText from "../Input/FeedbackText";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question3CoachingMethodology = ({
  growthSupportFeedback,
  updateFormData,
  onEnterKeyPress,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with the coaching methodology"}
        subtitle={
          "Tell us more about if and how the coaching steps and structure help you."
        }
      >
        <FeedbackHeader
          title={
            "How did coaching support your personal or professional growth?"
          }
        />
        <FeedbackText
          inputID={"growthSupportFeedback"}
          inputText={growthSupportFeedback}
          updateFormData={updateFormData}
          onEnterKeyPress={onEnterKeyPress}
          placeHolder={"E.g. goal setting, confidence building"}
        />
      </FeedbackFormLayout>
    </>
  );
};
